import Grid from '../components/grid'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { CMSLink } from '../v2/components/CMSLink'
import { ListItem } from './ContentBlockOne'
import { Page } from '@telesoft/types/payload-types'
import cn from 'classnames'
import React from 'react'

export type CenterBulletPointsBlockProps = Extract<
  Page['blocks'][0],
  { blockType: 'center-bullet-points' }
>

function CenterBulletPoints(block: CenterBulletPointsBlockProps) {
  const { title, subTitle, items, options } = block
  const link = options?.link
  const hasButton = options?.hasButton

  return (
    <Container>
      <Grid>
        <div
          className={
            'col-span-full p-8 md:p-12 lg:p-20 bg-accent-1 flex flex-col justify-center items-start'
          }
        >
          <div className={'mx-auto flex flex-col justify-center items-start'}>
            {subTitle && (
              <Text
                variant="heading"
                className={cn('max-w-4xl w-full mb-4', {
                  'text-center': options?.variant === 'center',
                  'text-left': options?.variant === 'left',
                })}
              >
                {subTitle}
              </Text>
            )}
            {title && (
              <Text
                variant="mediumHeading"
                className={cn('max-w-4xl w-full mb-4', {
                  'text-center': options?.variant === 'center',
                  'text-left': options?.variant === 'left',
                })}
              >
                {title}
              </Text>
            )}

            <div className="mt-4 md:mt-8 grid grid-cols-1 gap-4 max-w-4xl space-y-2">
              {items?.map((item: any, i: number) => {
                return <ListItem key={`item--map--${i}`}>{item.item}</ListItem>
              })}
            </div>

            {hasButton && (
              <div
                className={cn('w-full flex', {
                  'justify-center': options?.variant === 'center',
                  'justify-start': options?.variant === 'left',
                })}
              >
                <CMSLink {...link} className="mt-4 md:mt-6 lg:mt-8" />
              </div>
            )}
          </div>
        </div>
      </Grid>
    </Container>
  )
}

export default CenterBulletPoints
